import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-c00b6b50"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 重置 ");

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 删除 ");

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 删除 ");

import { ref, onBeforeUnmount } from 'vue';
import { dateFormat, getVexTableProps } from '@/config';
import { getDownloadCenterList, deleteExportRecord, getDownloadUrl } from '@/request';
import { ElMessageBox, ElMessage } from 'element-plus';
export default {
  name: 'DownloadCenter',

  setup(__props) {
    const form = ref({
      excelName: '',
      startTime: '',
      endTime: ''
    });
    const table = ref();
    const tableOptions = getVexTableProps({
      loading: false,
      toolbarConfig: {
        loading: false
      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '用户',
        field: 'supUserName',
        width: '100px',
        showOverflow: true
      }, {
        title: '报表名称',
        field: 'excelName',
        width: '450px',
        showOverflow: true
      }, {
        title: '文件大小',
        field: 'size',
        width: '150px',
        showOverflow: true
      }, {
        title: '状态',
        slots: {
          default: 'status'
        }
      }, {
        title: '操作',
        slots: {
          default: 'operation'
        }
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getDownloadCenterList(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value)).then(data => {
              var _data$rows;

              data === null || data === void 0 ? void 0 : (_data$rows = data.rows) === null || _data$rows === void 0 ? void 0 : _data$rows.forEach(item => {
                item.size = item.excelSize + 'K';
              });
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });

    function del(row) {
      ElMessageBox.confirm('是否确认删除该条记录?', {
        title: '删除',
        cancelButtonText: '取消',
        confirmButtonText: '确认'
      }).then(() => {
        deleteExportRecord({
          recordId: row.supExportTaskId,
          __repeat: true,
          __warn: true
        }).then(data => {
          if (data !== null && data !== void 0 && data.success) {
            ElMessage.success('操作成功!');
            table.value.commitProxy('query');
          }
        });
      });
    }

    function download(row) {
      getDownloadUrl({}, {
        params: {
          recordId: row.supExportTaskId,
          __repeat: true,
          __warn: true
        }
      }).then(data => {
        if (data.success) {
          window.open(data.url, '_blank');
        }
      });
    }

    const timer = setInterval(() => {
      table.value.commitProxy('query');
    }, 5000);
    onBeforeUnmount(() => {
      clearTimeout(timer);
    });

    function reset() {
      form.value = {
        excelName: '',
        startTime: '',
        endTime: ''
      };
      table.value.commitProxy('reload');
    }

    return (_ctx, _cache) => {
      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        inline: true
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "开始时间"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: form.value.startTime,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.startTime = $event),
            type: "date",
            "value-format": _unref(dateFormat)
          }, null, 8, ["modelValue", "value-format"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "截止时间"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: form.value.endTime,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.endTime = $event),
            type: "date",
            "value-format": _unref(dateFormat)
          }, null, 8, ["modelValue", "value-format"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "报表名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.excelName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.excelName = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: "Search",
            onClick: _cache[3] || (_cache[3] = $event => table.value.commitProxy('reload'))
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            icon: "Refresh",
            onClick: reset
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        loading: false,
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        status: _withCtx(({
          row
        }) => [row.downloadState === 2 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          icon: "Download",
          onClick: $event => download(row)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(row.downloadStateStr), 1)]),
          _: 2
        }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          icon: "Download",
          disabled: ""
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(row.downloadStateStr), 1)]),
          _: 2
        }, 1024))]),
        operation: _withCtx(({
          row
        }) => [row.downloadState === 2 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "danger",
          icon: "Delete",
          onClick: $event => del(row)
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 2
        }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "danger",
          icon: "Delete",
          disabled: ""
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }))]),
        _: 1
      }, 16)]);
    };
  }

};